import { render, staticRenderFns } from "./CardAdministracao.vue?vue&type=template&id=bf73b8ce&scoped=true"
import script from "./CardAdministracao.vue?vue&type=script&lang=js"
export * from "./CardAdministracao.vue?vue&type=script&lang=js"
import style0 from "./CardAdministracao.vue?vue&type=style&index=0&id=bf73b8ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf73b8ce",
  null
  
)

export default component.exports